// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import memberCollectionActionTypes from './member-collection.types';
import {
	fetchSearchMemberLoanList,
	fetchMemberLoanInfo,
	memberCollectionUpdateAPI,
	memberDeathUpdateAPI,
	interestWaiverUpdateAPI,
	memberCollectionRevertAPI,
	memberCollectionFetchAPI,
	memberWalletFetchAPI,
	memberQrFetchAPI,
	memberRepaymentFetchAPI,
	memberWalletRevertAPI,
	getMemberLoanCardPDF,
	geMemberLoanCardReport,
	getMemberRepaymentPDF,
	memberLoanCollectionApprovalAPI,
	memberWalletAddAPI,
	memberLoanPaidEntry,
	memberArrearLoanPaidEntry,
	getThriftCollectionDetailsApi,
	revertThriftCollectionCall,
} from './member-collection.service';
import {
	getSearchMemberLoanListSuccess,
	getSearchMemberLoanListFailure,
	getSearchMemberLoanListResponseChanged,
	getMemberLoanInfoSuccess,
	getMemberLoanInfoFailure,
	getMemberLoanInfoResponseChanged,
	updateMemberCollectionResponseChanged,
	updateMemberCollectionSuccess,
	updateMemberCollectionFailure,
	updateMemberDeathResponseChanged,
	updateMemberDeathSuccess,
	updateMemberDeathFailure,
	updateInterestWaiverResponseChanged,
	updateInterestWaiverSuccess,
	updateInterestWaiverFailure,
	revertMemberCollectionResponseChanged,
	revertMemberCollectionSuccess,
	revertMemberCollectionFailure,
	fetchMemberCollectionResponseChanged,
	fetchMemberCollectionSuccess,
	fetchMemberCollectionFailure,
	fetchMemberWalletResponseChanged,
	fetchMemberWalletSuccess,
	fetchMemberWalletFailure,
	addMemberWalletSuccess,
	addMemberWalletFailure,
	addMemberWalletResponseChanged,
	fetchMemberQrResponseChanged,
	fetchMemberQrSuccess,
	fetchMemberQrFailure,
	fetchMemberRepaymentResponseChanged,
	fetchMemberRepaymentSuccess,
	fetchMemberRepaymentFailure,
	revertMemberWalletFailure,
	revertMemberWalletResponseChanged,
	revertMemberWalletSuccess,
	getMemeberLoanCardPDFFailure,
	getMemeberLoanCardPDFSuccess,
	getMemeberLoanCardPDFResponseChanged,
	getMemeberRepaymentPDFFailure,
	getMemebeRepaymentPDFSuccess,
	getMemeberLoanCardReportFailure,
	getMemeberLoanCardReportSuccess,
	getMemeberLoanCardReportResponseChanged,
	memberLoanCollectionApprovalFailure,
	memberLoanCollectionApprovalSuccess,
	memberLoanCollectionApprovalResponseChanged,
	memberCollectionLoanPaidFailure,
	memberCollectionLoanPaidSuccess,
	memberCollectionLoanPaidReponseChanged,
	memberCollectionLoanPaidArrearFailure,
	memberCollectionLoanPaidArrearSuccess,
	memberCollectionLoanPaidArrearReponseChanged,
	getThriftCollectionDetailsFailure,
	getThriftCollectionDetailsSuccess,
	getThriftCollectionDetailsResponseChanged,
	revertThriftCollectionFailure,
	revertThriftCollectionSuccess,
	revertThriftCollectionResponseChanged,
} from './member-collection.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START SEARCH MEMBER LOAN LIST DETAILS  ******************** */
export function* getSearchMemberLoanList({ payload }: any) {
	try {
		const key = 'searchMemberLoanListKey';
		const {
			searchMemberValue,
			searchMemberType,
			memberCompanyID,
			userID,
			userRole,
			userLevel,
			databaseName,
			provisionType,
		} = payload;
		const jsonData = {
			SearchMemberValue: searchMemberValue,
			SearchMemberType: searchMemberType,
			MemberCompanyID: memberCompanyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSearchMemberLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSearchMemberLoanListFailure(responseData.data));
		} else {
			yield put(getSearchMemberLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSearchMemberLoanListFailure(error));
	}
}

export function* resetGetSearchMemberLoanListResponse() {
	yield put(getSearchMemberLoanListResponseChanged());
}

export function* onGetSearchMemberLoanListDetails() {
	yield takeLatest(
		memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_START,
		getSearchMemberLoanList,
	);
}

export function* onGetSearchMemberLoanListResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_RESET,
		resetGetSearchMemberLoanListResponse,
	);
}
/** *********************  END GET SEARCH MEMBER LOAN LIST  ******************** */

/** *********************  START MEMBER LOAN INFO DETAILS  ******************** */
export function* getMemberLoanInfo({ payload }: any) {
	try {
		const key = 'LoanInfoMemberLoanListKey';
		const { loanIndexGroupMemberID, memberID, companyID, databaseName } = payload;
		const jsonData = {
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberLoanInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberLoanInfoFailure(responseData.data));
		} else {
			yield put(getMemberLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberLoanInfoFailure(error));
	}
}

export function* resetGetMemberLoanInfoResponse() {
	yield put(getMemberLoanInfoResponseChanged());
}

export function* onGetMemberLoanInfoDetails() {
	yield takeLatest(memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_START, getMemberLoanInfo);
}

export function* onGetMemberLoanInfoResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_RESPONSE_RESET,
		resetGetMemberLoanInfoResponse,
	);
}
/** *********************  END GET MEMBER LOAN INFO  ******************** */

/** *********************  START MEMBER COLLECTION UPDATE  ******************** */
export function* updateMemberCollectionList({ payload }: any) {
	try {
		const key = 'UpdateMemberCollectionDataKey';
		const {
			DatabaseName,
			CompanyID,
			UserID,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			BranchID,
			CenterID,
			GroupID,
			memberID,
			LoanIndexGroupMemberID,
			Amount,
			repayDate,
			receiptNumber,
			chequeNumber,
		} = payload;
		const jsonData = {
			DatabaseName: DatabaseName,
			CompanyID: CompanyID,
			UserID: UserID,
			fiveHundred: fiveHundred,
			twoHundred: twoHundred,
			hundred: hundred,
			fifty: fifty,
			twenty: twenty,
			ten: ten,
			five: five,
			two: two,
			one: one,
			totalDenominationAmount: totalDenominationAmount,
			BranchID: BranchID,
			LocationID: CenterID,
			GroupID: GroupID,
			Member: memberID,
			LoanIndexGroupMemberID: LoanIndexGroupMemberID,
			RecivedAmount: Amount,
			memberCollectionDate: repayDate,
			ReceiptNumber: receiptNumber,
			ChequeNumber: chequeNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberCollectionUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberCollectionFailure(responseData.data));
		} else {
			yield put(updateMemberCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberCollectionFailure(error));
	}
}

export function* resetMemberCollectionUpdateResponse() {
	yield put(updateMemberCollectionResponseChanged());
}

export function* onMemberCollectionUpdate() {
	yield takeLatest(
		memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_START,
		updateMemberCollectionList,
	);
}

export function* onMemberCollectionUpdateResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_RESPONSE_RESET,
		resetMemberCollectionUpdateResponse,
	);
}
/** *********************  END MEMBER COLLECTION UPDATE  ******************** */

/** *********************  UPDATE MEMBER DEATH LIST START  ******************** */
export function* updateMemberDeathList({ payload }: any) {
	try {
		const key = 'UpdateMemberDeathDetailsKey';
		const {
			databaseName,
			memberID,
			companyID,
			userID,
			loanIndexGroupMemberID,
			deathDate,
			deathPlace,
			deathReason,
			isDeadDemandRequired,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			DeathDate: deathDate,
			DeathPlace: deathPlace,
			DeathReason: deathReason,
			IsDeadDemandRequired: isDeadDemandRequired,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDeathUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberDeathFailure(responseData.data));
		} else {
			yield put(updateMemberDeathSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberDeathFailure(error));
	}
}

export function* resetMemberDeathUpdateResponse() {
	yield put(updateMemberDeathResponseChanged());
}

export function* onMemberDeathUpdate() {
	yield takeLatest(memberCollectionActionTypes.UPDATE_MEMBER_DEATH_START, updateMemberDeathList);
}

export function* onMemberDeathUpdateResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.UPDATE_MEMBER_DEATH_RESPONSE_RESET,
		resetMemberDeathUpdateResponse,
	);
}
/** *********************  UPDATE MEMBER DEATH LIST END  ******************** */

/** *********************  UPDATE INTEREST WAIVER LIST START  ******************** */
export function* updateInterestWaiverList({ payload }: any) {
	try {
		const key = 'UpdateInterestWaiverDataKey';
		const WaiverDueLoans = JSON.stringify(payload.waiverDueLoans).replace(/"/g, "'");
		const {
			databaseName,
			companyID,
			userID,
			loanIndexGroupMemberID,
			memberID,
			interestWaiverAmount,
			interestWaiverReason,
			loanIndexID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			WaiverInterest: interestWaiverAmount,
			ReasonForInterestWaiver: interestWaiverReason,
			LoanIndexID: loanIndexID,
			WaiverDueLoans,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(interestWaiverUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateInterestWaiverFailure(responseData.data));
		} else {
			yield put(updateInterestWaiverSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateInterestWaiverFailure(error));
	}
}

export function* resetInterestWaiverUpdateResponse() {
	yield put(updateInterestWaiverResponseChanged());
}

export function* onInterestWaiverUpdate() {
	yield takeLatest(
		memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_START,
		updateInterestWaiverList,
	);
}

export function* onInterestWaiverUpdateResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_RESPONSE_RESET,
		resetInterestWaiverUpdateResponse,
	);
}
/** *********************  UPDATE INTEREST WAIVER LIST END  ******************** */

/** *********************  REVERT MEMBER COLLECTION LIST START ******************** */
export function* revertMemberCollectionList({ payload }: any) {
	try {
		const key = 'RevertMemberCollectionDataKey';
		const {
			databaseName,
			companyID,
			userID,
			arrearCollectionID,
			loanPaidID,
			serviceName,
			actualAmountReceived,
			amountEMIReceived,
			collectionDate,
			collectedDate,
			memberID,
			userName,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			ArrearCollectionID: arrearCollectionID,
			DueID: loanPaidID,
			ServiceName: serviceName,
			AmountEMIReceived: amountEMIReceived,
			ActualAmountReceived: actualAmountReceived,
			CollectionDate: collectionDate,
			CollectedDate: collectedDate,
			LoanPaidID: loanPaidID,
			MemberID: memberID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			memberCollectionRevertAPI,
			encodeData,
			jsonData.ServiceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertMemberCollectionFailure(responseData.data));
		} else {
			yield put(revertMemberCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertMemberCollectionFailure(error));
	}
}

export function* resetMemberCollectionRevertResponse() {
	yield put(revertMemberCollectionResponseChanged());
}

export function* onMemberCollectionRevert() {
	yield takeLatest(
		memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_START,
		revertMemberCollectionList,
	);
}

export function* onMemberCollectionRevertResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_RESPONSE_RESET,
		resetMemberCollectionRevertResponse,
	);
}
/** *********************  REVERT MEMBER COLLECTION LIST END ******************** */

/** *********************  FETCH MEMBER COLLECTION LIST START ******************** */
export function* fetchMemberCollectionList({ payload }: any) {
	try {
		const key = 'FetchMemberCollectionDataKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			loanIndexGroupMemberID,
			amount,
			loanPaidID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			Member: memberID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			RevertAmount: amount,
			DueID: loanPaidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberCollectionFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberCollectionFailure(responseData.data));
		} else {
			yield put(fetchMemberCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberCollectionFailure(error));
	}
}

export function* resetMemberCollectionFetchResponse() {
	yield put(fetchMemberCollectionResponseChanged());
}

export function* onMemberCollectionDetailsFetch() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_COLLECTION_START,
		fetchMemberCollectionList,
	);
}

export function* onMemberCollectionDetailsFetchResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_COLLECTION_RESPONSE_RESET,
		resetMemberCollectionFetchResponse,
	);
}
/** *********************  FETCH MEMBER COLLECTION LIST END ******************** */

/** *********************  FETCH MEMBER WALLET LIST START ******************** */
export function* fetchMemberWalletList({ payload }: any) {
	try {
		const key = 'FetchMemberWalletDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberWalletFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberWalletFailure(responseData.data));
		} else {
			yield put(fetchMemberWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberWalletFailure(error));
	}
}

export function* resetMemberWalletFetchResponse() {
	yield put(fetchMemberWalletResponseChanged());
}

export function* onMemberWalletDetailsFetch() {
	yield takeLatest(memberCollectionActionTypes.GET_MEMBER_WALLET_START, fetchMemberWalletList);
}

export function* onMemberWalletDetailsFetchResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_WALLET_RESPONSE_RESET,
		resetMemberWalletFetchResponse,
	);
}
/** *********************  FETCH MEMBER WALLET LIST END ******************** */

/** *********************  ADD MEMBER WALLET LIST START ******************** */
export function* addMemberWalletList({ payload }: any) {
	try {
		const key = 'AddAmountToWalletKey';
		const {
			databaseName,
			companyID,
			userID,
			loanIndexGroupMemberID,
			memberID,
			walletAmount,
			paidDate,
			loanpaidID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			WalletAmount: walletAmount,
			CreatedBy: userID,
			PaidDate: paidDate,
			LoanPaidID: loanpaidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberWalletAddAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberWalletFailure(responseData.data));
		} else {
			yield put(addMemberWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberWalletFailure(error));
	}
}

export function* resetMemberWalletAddResponse() {
	yield put(addMemberWalletResponseChanged());
}

export function* onMemberWalletDetailsAdd() {
	yield takeLatest(memberCollectionActionTypes.ADD_MEMBER_WALLET_START, addMemberWalletList);
}

export function* onMemberWalletDetailsAddResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.ADD_MEMBER_WALLET_RESPONSE_RESET,
		resetMemberWalletAddResponse,
	);
}
/** *********************  ADD MEMBER WALLET LIST END ******************** */

/** *********************  FETCH MEMBER QR LIST START ******************** */
export function* fetchMemberQrList({ payload }: any) {
	try {
		const key = 'FetchMemberQrDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberQrFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberQrFailure(responseData.data));
		} else {
			yield put(fetchMemberQrSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberQrFailure(error));
	}
}

export function* resetMemberQrFetchResponse() {
	yield put(fetchMemberQrResponseChanged());
}

export function* onMemberQrDetailsFetch() {
	yield takeLatest(memberCollectionActionTypes.GET_MEMBER_QR_START, fetchMemberQrList);
}

export function* onMemberQrDetailsFetchResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_QR_RESPONSE_RESET,
		resetMemberQrFetchResponse,
	);
}
/** *********************  FETCH MEMBER QR LIST START ******************** */

/** *********************  FETCH MEMBER REPAYMENT LIST START ******************** */
export function* fetchMemberRepaymentList({ payload }: any) {
	try {
		const key = 'FetchMemberRepaymentDataKey';
		const { databaseName, companyID, loanIndexGroupMemberID, memberID, branchID, centerID } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberRepaymentFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberRepaymentFailure(responseData.data));
		} else {
			yield put(fetchMemberRepaymentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberRepaymentFailure(error));
	}
}

export function* resetMemberRepaymentFetchResponse() {
	yield put(fetchMemberRepaymentResponseChanged());
}

export function* onMemberRepaymentDetailsFetch() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_REPAYMENT_START,
		fetchMemberRepaymentList,
	);
}

export function* onMemberRepaymentDetailsFetchResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_MEMBER_REPAYMENT_RESPONSE_RESET,
		resetMemberRepaymentFetchResponse,
	);
}
/** *********************  FETCH MEMBER REPAYMMENT LIST START ******************** */

/** *********************  REVERT MEMBER WALLET LIST START ******************** */
export function* revertMemberWalletList({ payload }: any) {
	try {
		const key = 'RevertMemberWalletDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID, savingAmountID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			SavingAmountID: savingAmountID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberWalletRevertAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertMemberWalletFailure(responseData.data));
		} else {
			yield put(revertMemberWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertMemberWalletFailure(error));
	}
}

export function* resetMemberWalletRevertResponse() {
	yield put(revertMemberWalletResponseChanged());
}

export function* onMemberWalletDetailsRevert() {
	yield takeLatest(
		memberCollectionActionTypes.DELETE_MEMBER_WALLET_START,
		revertMemberWalletList,
	);
}

export function* onMemberWalletDetailsRevertResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.DELETE_MEMBER_WALLET_RESPONSE_RESET,
		resetMemberWalletRevertResponse,
	);
}
/** *********************  REVERT MEMBER WALLET LIST END ******************** */

/** *********************  MEMBER LOAN CARD START ******************** */
export function* memberLoanCardPDFExport({ payload }: any) {
	try {
		const key = 'MemberLoanCardPDFKey';
		const { databaseName, companyID, loanIndexID, memberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMemberLoanCardPDF, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemeberLoanCardPDFFailure(responseData.data));
		} else {
			yield put(getMemeberLoanCardPDFSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemeberLoanCardPDFFailure(error));
	}
}

export function* getMemberLoanCardPDFResponse() {
	yield put(getMemeberLoanCardPDFResponseChanged());
}

export function* onMemberLoanCardPDF() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_START,
		memberLoanCardPDFExport,
	);
}

export function* onMemberLoanCardPDFResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_RESPONSE_RESET,
		getMemberLoanCardPDFResponse,
	);
}
/** *********************  MEMBER LOAN CARD END ******************** */

/** *********************  MEMBER REPAYMENT START ******************** */
export function* memberRepaymentPDFExport({ payload }: any) {
	try {
		const key = 'MemberRepaymentPDFKey';
		const {
			databaseName,
			companyID,
			loanIndexID,
			memberID,
			branchID,
			centerID,
			loanIndexGroupMemberID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMemberRepaymentPDF, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemeberRepaymentPDFFailure(responseData.data));
		} else {
			yield put(getMemebeRepaymentPDFSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemeberRepaymentPDFFailure(error));
	}
}

export function* getRepaymentPDFResponse() {
	yield put(getMemeberLoanCardPDFResponseChanged());
}

export function* onGetRepaymentPDF() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_START,
		memberRepaymentPDFExport,
	);
}

export function* onMemberRepaymentPDFResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_RESPONSE_RESET,
		getRepaymentPDFResponse,
	);
}
/** *********************  MEMBER REPAYMENT END ******************** */

/** *********************  MEMBER LOAN CARD REPORT START ******************** */
export function* memberLoanCardReport({ payload }: any) {
	try {
		const key = 'LoanCardReportKey';
		const {
			databaseName,
			companyID,
			loanIndexID,
			memberID,
			branchID,
			centerID,
			userID,
			loanIndexGroupMemberID,
			generalCompanyID,
			requestID,
			groupID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			GeneralCompanyID: generalCompanyID,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexID: loanIndexID,
			GroupID: groupID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
			RequestID: requestID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(geMemberLoanCardReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemeberLoanCardReportFailure(responseData.data));
		} else {
			yield put(getMemeberLoanCardReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemeberLoanCardReportFailure(error));
	}
}

export function* getMemberLoanCardReport() {
	yield put(getMemeberLoanCardReportResponseChanged());
}

export function* onMemberLoanCardReport() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_START,
		memberLoanCardReport,
	);
}

export function* onMemberLoanCardReportResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_RESPONSE_RESET,
		getMemberLoanCardReport,
	);
}
/** *********************  MEMBER LOAN CARD REPORT END ******************** */

/** *********************  MEMBER LOAN COLLECTION APPROVAL START ******************** */
export function* memberLoanCollectionApproval({ payload }: any) {
	try {
		const key = 'MemberLoanCollectionApprovalKey';
		const { databaseName, companyID, loanPaidID, memberID, loanIndexGroupMemberID } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanPaidID: loanPaidID,
			MemberID: memberID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberLoanCollectionApprovalAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(memberLoanCollectionApprovalFailure(responseData.data));
		} else {
			yield put(memberLoanCollectionApprovalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(memberLoanCollectionApprovalFailure(error));
	}
}

export function* getMemberLoanCollectionApproval() {
	yield put(memberLoanCollectionApprovalResponseChanged());
}

export function* onMemberLoanCollectionApproval() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_START,
		memberLoanCollectionApproval,
	);
}

export function* onMemberLoanCollectionApprovalResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
		getMemberLoanCollectionApproval,
	);
}
/** *********************  MEMBER LOAN COLLECTION APPROVAL END ******************** */

/** *********************  MEMBER LOAN COLLECTION APPROVAL START ******************** */
export function* memberLoanPaidEntrySaga({ payload }: any) {
	try {
		const key = 'UpdateLoanPaidKey';
		const {
			twoThousand,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			arrearInterest,
			arrearPrincipal,
			amountReceived,
			penaltyAmount,
			penaltyPaidAmount,
			companyID,
			whenToPay,
			repaymetDate,
			advanceAmount,
			userID,
			payFromWalet,
			databaseName,
			uICollectionDate,
			collectedFrom,
			collectedBy,
			dueLeft,
			totalDue,
			loanIndexGroupMemberID,
			collectionMode,
			chequeNumber,
			receiptNumber,
			branchCashAccountID,
			branchBankAccountID,
			walletAccountID,
			infogCompanyID,
			memberUniqueID,
			memberName,
			branchID,
			paymentFrom,
			isThriftPayed,
			paidID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			TwoThousand: twoThousand,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenominationAmount: totalDenominationAmount,
			ArrearInterest: arrearInterest,
			ArrearPrincipal: arrearPrincipal,
			AmountReceived: amountReceived,
			PenaltyAmount: penaltyAmount,
			PenaltyPaidAmount: penaltyPaidAmount,
			WhenToPay: whenToPay,
			RepaymetDate: repaymetDate,
			AdvanceAmount: advanceAmount,
			UserID: userID,
			PayFromWalet: payFromWalet,
			UICollectionDate: uICollectionDate,
			CollectedFrom: collectedFrom,
			CollectedBy: collectedBy,
			DueLeft: dueLeft,
			TotalDue: totalDue,
			CollectionMode: collectionMode,
			ChequeNumber: chequeNumber,
			ReceiptNumber: receiptNumber,
			BranchCashAccountID: branchCashAccountID,
			BranchBankAccountID: branchBankAccountID,
			WalletAccountID: walletAccountID,
			InfogCompanyID: infogCompanyID,
			MemberUniqueID: memberUniqueID,
			MemberName: memberName,
			BranchID: branchID,
			PaymentFrom: paymentFrom,
			IsThriftPayed: isThriftPayed,
			PaidID: paidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberLoanPaidEntry, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(memberCollectionLoanPaidFailure(responseData.data));
		} else {
			yield put(memberCollectionLoanPaidSuccess(responseData.data));
		}
	} catch (error) {
		yield put(memberCollectionLoanPaidFailure(error));
	}
}

export function* memberCollectionLoanPaidResponse() {
	yield put(memberCollectionLoanPaidReponseChanged());
}

export function* onMemberLoanCollectionLoanPaidEntry() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_START,
		memberLoanPaidEntrySaga,
	);
}

export function* onMemberLoanCollectionLoanPaidEntryResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET,
		memberCollectionLoanPaidResponse,
	);
}
/** *********************  MEMBER LOAN COLLECTION APPROVAL END ******************** */

/** *********************  MEMBER LOAN COLLECTION ARREAR LOAN PAID START ******************** */
export function* memberArrearLoanPaidEntrySaga({ payload }: any) {
	try {
		const key = 'updateArrearLoanPaidKey';
		const {
			paidID,
			arrearPrincipal,
			arrearInterest,
			amountReceived,
			companyID,
			databaseName,
			isArrearCollection,
			userID,
			userName,
			userAccessBranchID,
			advanceAmount,
			payFromWalet,
			loanIndexGroupMemberID,
			memberID,
			paymentFrom,
			isThriftPayed,
			thriftAmount,
			additionalChargesPaid,
			collectionMode,
			receiptNumber,
			twoThousand,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			penaltyPaidAmount,
			repaymetDate,
			recivedArrearPrinciple,
			recivedArrearInterest,
		} = payload;
		const jsonData = {
			TwoThousand: twoThousand,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenominationAmount: totalDenominationAmount,
			LoanPaidID: paidID,
			ArreaLoanPrincipal: arrearPrincipal,
			ArreaLoanInterest: arrearInterest,
			ReceivedArrearPrincipal: recivedArrearPrinciple,
			ReceivedArrearInterest: recivedArrearInterest,
			TotalArrearReceivedLoanAmount: amountReceived,
			TotalPenaltyPaidAmount: penaltyPaidAmount,
			CompanyID: companyID,
			ArrearCollectionDate: repaymetDate,
			DatabaseName: databaseName,
			IsArrearCollection: isArrearCollection,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			AdvanceAmount: advanceAmount,
			PayFromWalet: payFromWalet,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			PaymentFrom: paymentFrom,
			IsThriftPayed: isThriftPayed,
			ThriftAmount: thriftAmount,
			AdditionalChargesPaid: additionalChargesPaid,
			CollectionMode: collectionMode,
			ReceiptNumber: receiptNumber,
			PaidID: paidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberArrearLoanPaidEntry, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(memberCollectionLoanPaidArrearFailure(responseData.data));
		} else {
			yield put(memberCollectionLoanPaidArrearSuccess(responseData.data));
		}
	} catch (error) {
		yield put(memberCollectionLoanPaidArrearFailure(error));
	}
}

export function* memberArrearCollectionLoanPaidResponse() {
	yield put(memberCollectionLoanPaidArrearReponseChanged());
}

export function* onMemberLoanArrearCollectionLoanPaidEntry() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START,
		memberArrearLoanPaidEntrySaga,
	);
}

export function* onMemberLoanArrearCollectionLoanPaidEntryResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET,
		memberArrearCollectionLoanPaidResponse,
	);
}
/** *********************  MEMBER LOAN COLLECTION ARREAR LOAN PAID ENTRY END ******************** */

/************************ GET THRIFT COLLECTION DETAILS SAGAS ****************** */
export function* getThriftCollectionDetailsSaga({ payload }: any) {
	try {
		const key = 'GetThriftCollectionDetailsKey';
		const {
			databaseName,
			companyID,
			fromDate,
			toDate,
			collectionFrom,
			officerID,
			areaID,
			branchID,
			groupID,
			memberID,
			loanIndexGroupMemberID,
		} = payload;

		const jsonData = {
			FromDate: fromDate,
			ToDate: toDate,
			CompanyID: companyID,
			DatabaseName: databaseName,
			CollectionFrom: collectionFrom,
			OfficerID: officerID,
			GroupID: groupID,
			AreaID: areaID,
			BranchID: branchID,
			MemberID: memberID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getThriftCollectionDetailsApi, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getThriftCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getThriftCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getThriftCollectionDetailsFailure(error));
	}
}

export function* getThriftCollectionDetailsResponse() {
	yield put(getThriftCollectionDetailsResponseChanged());
}

export function* onGetThriftCollectionDetailsStart() {
	yield takeLatest(
		memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_START,
		getThriftCollectionDetailsSaga,
	);
}

export function* onGetThriftCollectionDetailsResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_RESPONSE_RESET,
		getThriftCollectionDetailsResponse,
	);
}
/************************ GET THRIFT COLLECTION DETAILS END ****************** */

/************************ REVERT THRIFT COLLECTION SAGAS ****************** */
export function* revertThriftCollectionSaga({ payload }: any) {
	try {
		const key = 'revertThriftCollectionKey';
		const {
			loanIndexGroupMemberID,
			memberID,
			companyID,
			databaseName,
			userID,
			myThriftID,
			thriftScheduleID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			MyThriftID: myThriftID,
			ThriftScheduleID: thriftScheduleID,
			UserID: userID,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(revertThriftCollectionCall, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertThriftCollectionFailure(responseData.data));
		} else {
			yield put(revertThriftCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertThriftCollectionFailure(error));
	}
}

export function* revertThriftCollectionResponse() {
	yield put(revertThriftCollectionResponseChanged());
}

export function* onRevertThriftCollectionStart() {
	yield takeLatest(
		memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_START,
		revertThriftCollectionSaga,
	);
}

export function* onRevertThriftCollectionResponseReset() {
	yield takeLatest(
		memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_RESPONSE_RESET,
		revertThriftCollectionResponse,
	);
}
/************************ REVERT THRIFT COLLECTION END ****************** */

export function* memberCollectionSaga() {
	yield all([
		call(onGetSearchMemberLoanListDetails),
		call(onGetSearchMemberLoanListResponseReset),
		call(onGetMemberLoanInfoDetails),
		call(onGetMemberLoanInfoResponseReset),
		call(onMemberCollectionUpdate),
		call(onMemberCollectionUpdateResponseReset),
		call(onMemberDeathUpdate),
		call(onMemberDeathUpdateResponseReset),
		call(onInterestWaiverUpdate),
		call(onInterestWaiverUpdateResponseReset),
		call(onMemberCollectionRevert),
		call(onMemberCollectionRevertResponseReset),
		call(onMemberCollectionDetailsFetch),
		call(onMemberCollectionDetailsFetchResponseReset),
		call(onMemberWalletDetailsFetch),
		call(onMemberWalletDetailsFetchResponseReset),
		call(onMemberQrDetailsFetch),
		call(onMemberQrDetailsFetchResponseReset),
		call(onMemberRepaymentDetailsFetch),
		call(onMemberRepaymentDetailsFetchResponseReset),
		call(onMemberWalletDetailsRevert),
		call(onMemberWalletDetailsRevertResponseReset),
		call(onMemberLoanCardPDFResponseReset),
		call(onMemberLoanCardPDF),
		call(onGetRepaymentPDF),
		call(onMemberRepaymentPDFResponseReset),
		call(onMemberLoanCardReport),
		call(onMemberLoanCardReportResponseReset),
		call(onMemberLoanCollectionApproval),
		call(onMemberLoanCollectionApprovalResponseReset),
		call(onMemberWalletDetailsAdd),
		call(onMemberWalletDetailsAddResponseReset),
		call(onMemberLoanCollectionLoanPaidEntry),
		call(onMemberLoanCollectionLoanPaidEntryResponseReset),
		call(onMemberLoanArrearCollectionLoanPaidEntry),
		call(onMemberLoanArrearCollectionLoanPaidEntryResponseReset),
		call(onGetThriftCollectionDetailsStart),
		call(onGetThriftCollectionDetailsResponseReset),
		call(onRevertThriftCollectionResponseReset),
		call(onRevertThriftCollectionStart),
	]);
}
